/* Royal Coffee storefront analytics. Does not collect checkout or purchase events. */
(function () {
  'use strict';

  var measurementId = 'G-KVDZRQJ6R7';
  var shopify = window.Shopify;
  var loader = document.querySelector('script[data-rc-ga4]');
  if (!loader || !shopify || shopify.designMode || window.rcGa4Initialized) return;

  var current = new URL(window.location.href);
  if (!/^(www\.)?royalcoffee\.com$/.test(current.hostname)) return;
  if (current.searchParams.has('preview_theme_id')) return;

  // Account, payment and report URLs can contain customer identifiers or tokens.
  var privatePath = /\/(?:account|checkouts?|orders|gift_cards|apps|search)(?:\/|$)|\/pages\/(?:my-account|online-orders|paid-invoices|unpaid-invoices|bills-of-lading|customer-positions|customer-usage|historical-positions|organic-certificates)(?:\/|$)/i;
  if (privatePath.test(current.pathname)) return;

  var page = new URL(loader.getAttribute('data-page-location'), current.origin);
  page.search = '';
  page.hash = '';
  // Keep conventional campaign parameters; omit all other query values.
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (key) {
    var value = current.searchParams.get(key);
    if (value) page.searchParams.set(key, value);
  });

  var referrer = '';
  if (document.referrer) {
    try {
      // The referring host is sufficient for source attribution; no private paths.
      referrer = new URL(document.referrer).origin + '/';
    } catch (error) { /* Leave malformed referrers empty. */ }
  }

  window.rcGa4Initialized = true;
  var tagRequested = false;
  var tagLoaded = false;
  var configured = false;
  var consentAllowed = false;
  var disableKey = 'ga-disable-' + measurementId;
  window[disableKey] = true;

  function consent(allowed) {
    return {
      analytics_storage: allowed ? 'granted' : 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    };
  }

  function syncConsent() {
    var allowed = false;
    try {
      allowed = !!(shopify.customerPrivacy && shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { /* Fail closed if Shopify cannot establish permission. */ }
    window[disableKey] = !allowed;

    if (!allowed) {
      if (consentAllowed) window.gtag('consent', 'update', consent(false));
      consentAllowed = false;
      return;
    }

    if (!tagRequested) {
      tagRequested = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', consent(false));
      window.gtag('js', new Date());
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
      script.referrerPolicy = 'origin';
      script.onload = function () {
        tagLoaded = true;
        syncConsent();
      };
      document.head.appendChild(script);
      return;
    }
    // Recheck permission after download; revoked consent must not replay a view.
    if (!tagLoaded) return;
    if (!consentAllowed) window.gtag('consent', 'update', consent(true));
    consentAllowed = true;
    if (configured) return;
    configured = true;
    window.gtag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: page.href,
      page_referrer: referrer
    });
    window.gtag('event', 'page_view', {
      send_to: measurementId,
      page_location: page.href,
      page_referrer: referrer,
      page_title: document.title
    });
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (shopify.customerPrivacy) {
    syncConsent();
  } else if (typeof shopify.loadFeatures === 'function') {
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncConsent();
      });
    } catch (error) { /* Leave analytics disabled when the consent API cannot load. */ }
  }
})();
